import LogosSlider from './logos-slider';

export default class LogosSliderDesktop extends LogosSlider {
}
